import { zql } from "../generatedDrizzleSchema";

/**
  A grant targets exactly one principal (userId, userGroupId, or serviceAccountId,
  never more than one) and exactly one role (builtinRoleId or customRole, never both).
*/
export type GrantRow = {
  userGroupId: string | null;
  userId: string | null;
  serviceAccountId?: string | null;
  builtinRoleId: string | null;
  customRole?: {
    rolePermissions?: ReadonlyArray<{ permission: string }>;
  } | null;
};

export function grantsForScope(scopeId: string, tenantId: string) {
  return zql.roleGrants
    .where("scopeId", scopeId)
    .where("tenantId", tenantId)
    .related("customRole", (cr) => cr.related("rolePermissions"));
}

type Principal =
  | { userId: string }
  | { userGroupId: string }
  | { serviceAccountId: string };

export function grantsForPrincipal(principal: Principal, tenantId: string) {
  return zql.roleGrants
    .where("tenantId", tenantId)
    .where(({ cmp }) =>
      "userId" in principal
        ? cmp("userId", principal.userId)
        : "userGroupId" in principal
          ? cmp("userGroupId", principal.userGroupId)
          : cmp("serviceAccountId", principal.serviceAccountId)
    )
    .related("customRole", (cr) => cr.related("rolePermissions"));
}

export function buildUserGroupMemberships(
  grants: ReadonlyArray<{ userId: string | null; scopeId: string }>
): ReadonlyMap<string, readonly string[]> {
  const map = new Map<string, string[]>();
  for (const g of grants) {
    if (!g.userId) continue;
    let arr = map.get(g.userId);
    if (!arr) {
      arr = [];
      map.set(g.userId, arr);
    }
    arr.push(g.scopeId);
  }
  return map;
}
